module.exports = __webpack_public_path__ + "static/img/1077_big.87df8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1077_big.png
// module id = Zi2z
// module chunks = 1